"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invitationPayloadSchema = exports.invitationListQuerySchema = exports.INVITATION_LIST_ORDER = exports.INVITATION_LIST_SORT = exports.INVITATION_STATUS = void 0;
const zod_1 = require("zod");
const roles_1 = require("../roles");
const common_1 = require("./common");
exports.INVITATION_STATUS = ['pending', 'accepted', 'expired', 'revoked'];
exports.INVITATION_LIST_SORT = ['created_at', 'expires_at'];
exports.INVITATION_LIST_ORDER = ['asc', 'desc'];
exports.invitationListQuerySchema = zod_1.z
    .object({
    search: common_1.optionalTrimmedString,
    status: zod_1.z.enum(exports.INVITATION_STATUS).optional(),
    sort: zod_1.z.enum(exports.INVITATION_LIST_SORT).optional(),
    order: zod_1.z.enum(exports.INVITATION_LIST_ORDER).optional(),
})
    .strict();
// Email is fixed by the existing invitation row and never carried in this payload.
exports.invitationPayloadSchema = zod_1.z
    .object({
    userRole: roles_1.appRoleSchema,
    approverRoles: zod_1.z.array(roles_1.appRoleSchema).default([]),
})
    .strict();
//# sourceMappingURL=manage-invitation.schema.js.map